// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3KRlq","signatureBlock":"Footer_signatureBlock__3weLy","signature":"Footer_signature__2W20K"};